import { action } from 'satcheljs';
import type { ActionMessage } from 'satcheljs';
import type { DetailPaneContent } from 'owa-personal-os-types';

export interface OnDetailPaneOpenedActionMessage extends ActionMessage {
    content: DetailPaneContent;
}

export const onDetailPaneOpened: (content: DetailPaneContent) => OnDetailPaneOpenedActionMessage =
    action('onDetailPaneOpened', (content: DetailPaneContent) => ({
        content,
    }));

export const onDetailPaneClosed: () => ActionMessage = action('onDetailPaneClosed');
